export const months = [
	{
		value: "1",
		text: "Janeiro",
	},
	{
		value: "2",
		text: "Fevereiro",
	},
	{
		value: "3",
		text: "Março",
	},
	{
		value: "4",
		text: "Abril",
	},
	{
		value: "5",
		text: "Maio",
	},
	{
		value: "6",
		text: "Junho",
	},
	{
		value: "7",
		text: "Julho",
	},
	{
		value: "8",
		text: "Agosto",
	},
	{
		value: "9",
		text: "Setembro",
	},
	{
		value: "10",
		text: "Outubro",
	},
	{
		value: "11",
		text: "Novembro",
	},
	{
		value: "12",
		text: "Dezembro",
	},
];

export const states = [
	{ text: "AC", value: "AC" },
	{ text: "AL", value: "AL" },
	{ text: "AP", value: "AP" },
	{ text: "AM", value: "AM" },
	{ text: "BA", value: "BA" },
	{ text: "CE", value: "CE" },
	{ text: "DF", value: "DF" },
	{ text: "ES", value: "ES" },
	{ text: "GO", value: "GO" },
	{ text: "MA", value: "MA" },
	{ text: "MT", value: "MT" },
	{ text: "MS", value: "MS" },
	{ text: "MG", value: "MG" },
	{ text: "PA", value: "PA" },
	{ text: "PB", value: "PB" },
	{ text: "PR", value: "PR" },
	{ text: "PE", value: "PE" },
	{ text: "PI", value: "PI" },
	{ text: "RJ", value: "RJ" },
	{ text: "RN", value: "RN" },
	{ text: "RS", value: "RS" },
	{ text: "RO", value: "RO" },
	{ text: "RR", value: "RR" },
	{ text: "SC", value: "SC" },
	{ text: "SP", value: "SP" },
	{ text: "SE", value: "SE" },
	{ text: "TO", value: "TO" },
];

export const minWidth800BP = "(min-width: 800px)";
export const MIN_WIDTH_LARGE_DESKTOP = "(min-width: 1200px)";

export const ACCESS_TK = "ACCESS_TK";
export const LOCAL_STORAGE_DEVICE_ID_KEY = "FGTS_DEVICE_ID";
export const LOCAL_STORAGE_SESSION_ID = "FGTS_SESSION_ID";
export const VIVO = "VIVO";
export const TAX_MONTHLY_RATE = "1.79%";
export const DDI = {
	BR: "+55",
};

export const MIN_YEARS_ANTICIPATION = 1;
export const MAX_YEARS_ANTICIPATION = 5;
export const MIN_VALUE_ANTICIPATION = 300;
export const CONNECT_FGTS_CALLS_DELAY = 5 * 1000;
export const CONNECT_FGTS_TIMEOUT = 5 * 60 * 1000;
export const HEIGHT_GRID_LOGO = 80;
export const MAX_AGE = 90;
export const DEFAULT_COOKIE_AGE_IN_SECONDS = 3600;

export const LINK_FGTS_APP_ANDROID =
	"https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador&hl=pt_BR&gl=US";
export const LINK_FGTS_APP_IOS = "https://apps.apple.com/br/app/fgts/id1038441027";
export const LINK_FGTS_WEB = "https://www.fgts.gov.br/Paginas/trabalhador/app-fgts.aspx";
export const LINK_NOVERDE =
	"https://app.noverde.com.br/create-account?utm_source=vivo&utm_medium=&utm_campaign=ineleg&utm_term=&utm_content=";
export const LINK_ASK_LOAN = "https://www.vivomoney.com.br/pedir-emprestimo";
export const LINK_FAQ = "https://www.vivomoney.com.br/faq";
export const LINK_USER_AREA = "https://www.vivomoney.com.br/area-do-cliente";
export const LINK_CEP_CORREIOS = "https://buscacepinter.correios.com.br/app/endereco/index.php";

export const CUSTOMER_REFUSAL_MIN_MONTHS = "CUSTOMER_REFUSAL_MIN_MONTHS";
export const NOT_PRE_ELIGIBLE = "Client does not pre-eligible";
export const ERROR_ALREADY_OPERATION = "There is already an operation";
export const ERROR_PERIODS_NOT_FOUND = "Periods not found!";
export const ERROR_KEY_PIX_INCORRECT =
	"The disbursement need to be in a account with the same ownership as the borrower.";
export const ERROR_KEY_PIX_UNREGISTERED = "Pix Key is Unregistered";
export const ERROR_AMOUNT_AVAILABLE = "Amount available as least 300.0";
export const CF = "d6df7bc2-84a1-4dc5-b3cb-058f489ac46b"